export const getEWSRequestBodyTemplate = (body: string) =>
  `<?xml version="1.0" encoding="utf-8"?>
  <soap:Envelope
    xmlns:xsi="https://www.w3.org/2001/XMLSchema-instance"
    xmlns:xsd="https://www.w3.org/2001/XMLSchema"
    xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/"
    xmlns:t="http://schemas.microsoft.com/exchange/services/2006/types"
  >
    <soap:Header>
      <RequestServerVersion
        Version="Exchange2013"
        xmlns="http://schemas.microsoft.com/exchange/services/2006/types"
        soap:mustUnderstand="0"
      />
    </soap:Header>
    <soap:Body>
      ${body}
    </soap:Body>
  </soap:Envelope>
`;
